import React from "react";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

const RoleGuard = ({ children, allowedRoles }) => {
  const token = Cookies.get("vaghfnamaUser");
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const isCampaign = params.get("campaign") === "true";

  if (isCampaign) {
    return children;
  }

  if (!token) {
    return <Redirect to="/auth/login" replace />;
  }

  const decodedToken = JSON.parse(token);
  const userRoles = decodedToken.role || [];

  const hasAccess = allowedRoles.some((role) => userRoles.includes(role));

  if (!hasAccess) {
    return <Redirect to="/auth/unauthorized" replace />;
  }

  return children;
};

export default RoleGuard;
